export default {"src":"/_next/static/media/singles-icon.3b125d60.svg","height":12,"width":22,"blurWidth":0,"blurHeight":0};